module.exports = __webpack_public_path__ + "media/item_reveal5_legendary.29f586c3.wav";